/**
 @Description: 全局通用枚举
 */

/**
 * 本地开发代理配置
 */

const _dev = ""

export const EnumProxy = {
  DEV: _dev,
  SIT: '',
  UAT: '',
  PROD: ''
}

/**
 * 后端约定的请求响应的code状态码
 *
 */

export const EnumApiCode = {
  Success: 2000
}

export const throttleClick = []
